
<template>
  <div class="pa-5">
    <v-row no-gutters justify="center" align="center" class="py-6" v-if="isFetchingNotes">
      <div>
        <v-progress-circular
          indeterminate
          color="accent"
        />
      </div>
    </v-row>
    <template v-else>
      <note
        v-for="(note, i) in notes"
        :key="i"
        :note="note"
        class="pb-5"
      />
      <v-row no-gutters justify="center" align="center" class="py-6" v-if="!notes.length">
        <v-icon color="accent">sticky_note_2</v-icon>
        <div class="grey--text text--darken-1 pl-2 font-weight-medium">Aucune note sur cet équipment</div>
      </v-row>
      <div class="my-4">
        <v-expand-transition>
          <v-row no-gutters justify="center" align="center" v-show="canAddNote && !isAddingNote">
            <v-btn :disabled="!$canWrite" class="n-white-btn n-small-btn px-12" @click="$canWrite && (openNewNote($event))">
              <v-icon small class="mr-2">note_alt</v-icon>
              Nouvelle note
            </v-btn>
          </v-row>
        </v-expand-transition>
        <v-expand-transition>
          <div v-show="isAddingNote">
            <v-textarea
              v-model="newNote"
              ref="newNoteTextarea"
              hide-details
              no-resize
              solo
              height="140"
              background-color="rgba(255, 214, 65, 0.1)"
              :disabled="isSavingNewNote"
            />
            <v-row no-gutters justify="end" align="center" class="mt-3">
              <v-btn small tabindex="-1" text :disabled="isSavingNewNote" @click="isAddingNote = false">Annuler</v-btn>
              <v-btn :disabled="!$canWrite" small color="primary darken-1" :loading="isSavingNewNote" @click="$canWrite && (addNote($event))">Ajouter</v-btn>
            </v-row>
          </div>
        </v-expand-transition>
      </div>
    </template>
  </div>
</template>

<script>
import Note from '@/components/Equipments/Note.vue';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    equipment: {
      type: Object,
      required: false,
    },
    updatable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => ({
    notes: [],
    isFetchingNotes: false,
    isAddingNote: false,
    isSavingNewNote: false,
    newNote: ``,
  }),

  computed: {
    ...mapState(`model/user`, [
      `me`,
      `isAtLeastContributor`,
    ]),
    ...mapState(`model/client`, [
      `isSelfMaker`,
    ]),
    canAddNote() {
      return Boolean(this.isAtLeastContributor);
    },
  },

  methods: {
    ...mapActions(`model/equipmentNote`, {
      fetchEquipmentNotes: `fetchListForEquipment`,
      addEquipmentNote: `addForEquipment`,
    }),
    openNewNote() {
      this.isAddingNote = true;
      setTimeout(() => {
        this.$refs.newNoteTextarea.focus();
      }, 10);
    },
    async addNote() {
      this.isSavingNewNote = true;
      const note = await this.addEquipmentNote({
        equipmentId: this.equipment.id,
        note: this.newNote,
      });
      if (note) { this.notes.push(note); }
      this.isSavingNewNote = false;
      this.isAddingNote = false;
      // this.interventionChanged();
      setTimeout(() => {
        this.newNote = ``;
      }, 100);
    },
  },

  async beforeMount() {
    this.isFetchingNotes = true;
    this.notes = await this.fetchEquipmentNotes(this.equipment?.id);
    this.isFetchingNotes = false;
  },

  components: {
    Note,
  },
};
</script>

<style lang="scss" scoped>
</style>
